import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ROUTE_MAIN_PATHS } from '@app/app.routes.paths';
import { InviteRouteAction } from '@app/features/authentication/invite/invite-create-password.component';
import { AdminAuthService } from '@app/services/admin-auth/admin-auth.service';
import { AdminBootstrapService } from '@app/services/admin-bootstrap/admin-bootstrap.service';
import { AdminTenantService } from '@app/services/admin-tenant/admin-tenant.service';
import { catchError, map, of } from 'rxjs';

const BOUNCE_SNAPSHOT_ROUTES = [
  `/${ROUTE_MAIN_PATHS.login}`,
  `/${ROUTE_MAIN_PATHS.resetPassword}`,
  `/${ROUTE_MAIN_PATHS.forgotPassword}`,
  `/${ROUTE_MAIN_PATHS.join}`,
];

const authGuard = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const adminAuthService = inject(AdminAuthService);
  const adminTenantService = inject(AdminTenantService);
  const bootstrapService = inject(AdminBootstrapService);
  const isLoggedIn = adminAuthService.isLoggedIn();
  const isBounceRoute = BOUNCE_SNAPSHOT_ROUTES.some((route) =>
    state.url.startsWith(route)
  );
  //preaAdmin is when a user is updating their password in the process of upgrading to Admin role
  const preAdmin = _route?.data?.action === InviteRouteAction.updatePassword;

  /**
   * @bounce
   */
  if (
    (isBounceRoute && isLoggedIn && !preAdmin) ||
    (isLoggedIn && state.url === '/')
  ) {
    return bootstrapService.ensureTenantLoaded().pipe(
      map(() => router.parseUrl(adminTenantService.getDefaultLandingRoute())),
      catchError(() => {
        adminAuthService.signOutAndRedirect();
        return of(false);
      })
    );
  } else if (!isLoggedIn && state.url === '/') {
    router.navigate([ROUTE_MAIN_PATHS.login]);
    return false;
  } else if (isBounceRoute && !isLoggedIn) {
    return true;
  } else if (isLoggedIn) {
    return true;
  } else {
    router.navigate([ROUTE_MAIN_PATHS.login]);
    return false;
  }
};

export const authChildGuard: CanActivateChildFn = (childRoute, state) => {
  return authGuard(childRoute, state);
};

export const authRouteGuard: CanActivateFn = (route, state) => {
  return authGuard(route, state);
};
